var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3649 24.7148V22.3607C22.3649 21.1119 21.8688 19.9144 20.9859 19.0314C20.1029 18.1484 18.9053 17.6523 17.6566 17.6523H10.5941C9.34535 17.6523 8.14776 18.1484 7.26478 19.0314C6.3818 19.9144 5.88574 21.1119 5.88574 22.3607V24.7148",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1251 12.946C16.7254 12.946 18.8334 10.838 18.8334 8.23763C18.8334 5.63729 16.7254 3.5293 14.1251 3.5293C11.5247 3.5293 9.41675 5.63729 9.41675 8.23763C9.41675 10.838 11.5247 12.946 14.1251 12.946Z",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2C);
export default __webpack_public_path__ + "static/media/b2c.9da2f32b551177ae825f474cc181bb7a.svg";
export { ForwardRef as ReactComponent };